import type { LibraryTab } from "@/api";

/** The single source of truth mapping a Document Library tab to its route, so
 *  FilterBar's tab switcher and the Templates surface's inline switcher can't
 *  drift. */
export const LIBRARY_TAB_ROUTES: Record<LibraryTab, string> = {
    documents: "/organizations/document-library/documents",
    knowledge_base: "/organizations/document-library/knowledge-base",
    templates: "/organizations/document-library/templates",
};
